import React from 'react';
import PropTypes from 'prop-types';
import {sortedUniq} from 'lodash';

function FacetImages({facet}) {
	if (!facet) {
		return null;
	}

	console.log('facetImages', facet.properties);

	let images = Object.values(facet.properties).map(prop => prop.image);
	images = sortedUniq(images.sort());

	return (
		<span className="slx-mounting-facet-images">
			{images.map((image, index) => (
				<img
					key={image}
					src={image}
					className="slx-mounting-facet-image"
					/>
			))}
		</span>
	);
}

FacetImages.propTypes = {
	facet: PropTypes.object,
};

export default React.memo(FacetImages);
